import { render, staticRenderFns } from "./CommodityFlowStateInitEdit.vue?vue&type=template&id=df641558&scoped=true&"
import script from "./CommodityFlowStateInitEdit.vue?vue&type=script&lang=js&"
export * from "./CommodityFlowStateInitEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df641558",
  null
  
)

export default component.exports